export default "__VITE_ASSET__ncEbooYK__"